import { Breakpoints, styled } from '@vw-marketing/us-components';

const themeSizeGrid001 = '4vw';
const themeSizeGrid002 = '8vw';

interface WrapperProps {
  readonly margin?: any;
}

export const StyledGalleryWrapper = styled.div<WrapperProps>`
  display: flex;
  width: 100%;
  color: #000;
  overflow: hidden;
  margin: ${(props) => (props.margin?.mobile ? props.margin?.mobile : '')};

  @media (min-width: 767px) {
    padding: 0 ${themeSizeGrid001};
  }

  @media (min-width: ${Breakpoints.b960}px) {
    margin: ${(props) => (props.margin?.tablet ? props.margin?.tablet : '')};
    padding: 0 ${themeSizeGrid002};
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    margin: ${(props) => (props.margin?.desktop ? props.margin?.desktop : '')};
  }
`;

export const StyledGalleryContainer = styled.div`
  width: 100%;

  .video-gallery {
    display: grid;
  }

  .video-thumbnails-slider {
    display: flex;
    overflow: hidden;
    width: 100%;
    .video-gallery-nav {
      width: 100%;
      @media (min-width: 767px) {
        margin-top: 15px;
      }
      .slick-track {
      }
      .slick-slide {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
      }
      .slick-current .video-thumbnail img {
        border-color: #00437a;
      }
    }
  }
`;
